import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { IntlProvider } from "react-intl";
import Context from "../context";
import { getDefaultFormats } from "../formats";
import LuxonUtils from "@date-io/luxon";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { useTenantSettings } from "../hooks/useTenantSettings";
import { DEFAULT_DESIGN } from "../endpoints/loadTenantSettings";
import { useSettings } from "@ploy-lib/core";
import { useDesignSettings } from "../hooks/useDesignSettings";
const loaders = {
    tenant: (key) => import(
    /* webpackInclude: /tenant\.js$/, webpackChunkName: "tenants/[request]/tenant" */
    `../tenants/${key}/tenant.js`),
    messages: async (lang) => (await import(
    /* webpackInclude: /\.json$/, webpackChunkName: "lang/[request]" */
    `../translations/${lang.toLowerCase()}.json`))?.default
};
function CreateAdditions(dployBrandTheme) {
    return {
        formWebLogoDisabled: dployBrandTheme?.formWebLogoDisabled ?? false
    };
}
//
export function TenantProvider(props) {
    const settings = useSettings();
    const { tenantOverride, locale: currentLocale = props.locale || settings.locale, dateUtils = LuxonUtils, defaultCurrency = "NOK", defaultLocale = "nb-NO", children, theme: dployTheme, skipDesign, images } = props;
    let tenantName = props.tenant ?? settings.tenant ?? "Demo";
    if (tenantOverride?.startsWith(tenantName)) {
        tenantName = tenantOverride;
    }
    const defaultFormats = useMemo(() => getDefaultFormats(defaultCurrency), [defaultCurrency]);
    const { brand, formats, locale, messages, tenant } = useTenantSettings(tenantName, loaders, currentLocale, defaultLocale, images);
    let design = dployTheme?.design ?? settings.design ?? DEFAULT_DESIGN.id;
    design = tenant.designs[design] ? design : DEFAULT_DESIGN.id;
    const { theme } = useDesignSettings(tenant, skipDesign ? undefined : design, props.theme);
    const brandAdditions = CreateAdditions(dployTheme);
    const contextValue = useMemo(() => ({
        brand,
        formats,
        locale,
        messages,
        tenant,
        theme,
        design,
        brandAdditions
    }), [brand, design, formats, locale, messages, tenant, theme, brandAdditions]);
    return (_jsx(Context.Provider, { value: contextValue, children: _jsx(IntlProvider, { defaultLocale: defaultLocale, defaultFormats: defaultFormats, messages: messages, locale: locale, formats: formats, onError: error => {
                // Default onError behaviour is log error if NODE_ENV !== "production"
                if (process.env.NODE_ENV !== "production" &&
                    error.code !== "MISSING_TRANSLATION") {
                    console.error(error);
                }
            }, children: _jsx(MuiPickersUtilsProvider, { utils: dateUtils, locale: locale, children: _jsx(ThemeProvider, { theme: theme, children: children }) }) }) }));
}
//# sourceMappingURL=TenantProvider.js.map